import React, { useEffect, useRef } from "react";
import { TextField, TextFieldProps } from "@mui/material";

type Props = TextFieldProps & {
    allowNegative?: boolean;
}

export function NumberField(props: Props): JSX.Element {
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (ref.current) {
            const handler = (event: WheelEvent) => {
                const focusedElement = document.activeElement as HTMLInputElement | null;
                if (focusedElement === event.target) {
                    focusedElement?.blur();
                }
                if (props.onWheel) {
                    // @TODO fix type for this :'(
                    return props.onWheel(event as any);
                }
            };
            ref.current.addEventListener(
                'wheel',
                handler,
                { passive: false }
            );
            return () => {
                ref.current?.removeEventListener('wheel', handler);
            };
        }    }, [ref]);

    const { allowNegative, ...otherProps } = props;

    return (
        <TextField
            {...otherProps}
            ref={ref}
            type="number"
            onKeyDown={(event) => {
                if (event.keyCode === 38 || event.keyCode === 40) {
                    event.preventDefault();
                }
                if (props.onKeyDown) {
                    return props.onKeyDown(event);
                }            }}            onChange={(event) => {
                const value = event.target.value;
                const regex = allowNegative ? /^-?[0-9.]*$/ : /^[0-9.]*$/;
                if (props.onChange && regex.test(value)) {
                    return props.onChange(event);
                }
            }}
        />
    );
}